import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { isB2bDomain } from 'helpers/isDomainLocale';
import useTranslation from 'next-translate/useTranslation';
import { WishlistProductHeartEmptyIcon, WishlistProductHeartFullIcon } from 'public/svg/IconsSvg';
import { HTMLAttributes } from 'react';
import { ExtractNativePropsFromDefault } from 'typeHelpers/ExtractNativePropsFromDefault';
import twMerge from 'utils/twMerge';

type NativeProps = ExtractNativePropsFromDefault<HTMLAttributes<HTMLDivElement>, never, 'className'>;

type ProductWishlistButtonProps = {
    isWithText?: boolean;
    isProductInWishlist: boolean;
    toggleProductInWishlist: () => void;
};

const TEST_IDENTIFIER = 'wishlist-button';

export const ProductWishlistButton: FC<ProductWishlistButtonProps & NativeProps> = ({
    className,
    isWithText,
    isProductInWishlist,
    toggleProductInWishlist,
}) => {
    const { t } = useTranslation();
    const domainConfig = useDomainConfig();

    if (isB2bDomain(domainConfig)) {
        return null;
    }

    return (
        <div className={twMerge('mb-2 flex items-center', className)}>
            <div
                data-testid={TEST_IDENTIFIER}
                title={isProductInWishlist ? t('Remove product from wishlist') : t('Add product to wishlist')}
                className={twMerge(
                    'flex cursor-pointer items-center',
                    !isWithText && 'h-11 w-11 justify-center rounded-md',
                )}
                onClick={toggleProductInWishlist}
            >
                {isProductInWishlist ? (
                    <WishlistProductHeartFullIcon className="text-grey ml-0 mr-2 text-red" />
                ) : (
                    <WishlistProductHeartEmptyIcon className="text-grey ml-0 mr-2" />
                )}

                {isWithText && (
                    <span className="ml-1">
                        {isProductInWishlist ? t('Remove from wishlist') : t('Add to wishlist')}
                    </span>
                )}
            </div>
        </div>
    );
};

ProductWishlistButton.displayName = 'ProductWishlistButton';
